import {InjectionToken, NgModule} from '@angular/core';
import {GoogleMapConfig} from '../../../app/component/tools/google-maps-tool-module/models/google-map-config.model';
import {LayerCode} from '../../../app/shared/enum/layer-code.enum';

const GOOGLE_MAP_CONFIG: GoogleMapConfig = {
  featureConfig: [
    {
    fkIdentifyLayer: LayerCode.parzellen,
    fkIdentifyLayerId: 0,
    queryLayerId: LayerCode.f_parzellen,
    outfields: [
      'EIGENTUM',
      'GEMEINDE',
      'PARZNR',
      'EGRID',
      'LINIE',
      'KM_ANF',
      'KM_ENDE'
    ],
    style: {
      strokeColor: '#005CE6',
      fillOpacity: 0
    }
  },
    {
      fkIdentifyLayer: LayerCode.parzellen,
      fkIdentifyLayerId: 1,
      queryLayerId: LayerCode.f_teilparzelle,
      outfields: [
        'GEMEINDE',
        'PARZNR',
        'EIGENTUMSART',
        'FLAECHE_AUSGEGLICHEN',
        'EIGENTUEMER_TYP',
        'ANLAGE_NR',
        'FLAECHE_AUSGEGLICHEN'
      ],
      style: {
        fillColor: '#FFFF007F',
        strokeColor: '#4E4E4EFF',
        fillOpacity: 0.5
      },
      dynamicStyles: [{
          field: 'EIGENTUEMER_TYP',
          value: 1,
          fillColor: '#FFFF007F',
          strokeColor: '#4E4E4EFF',
          fillOpacity: 0.5
        },
        {
          field: 'EIGENTUEMER_TYP',
          value: 2,
          strokeColor: '#4E4E4EFF',
          fillColor: '#FF73DF7F',
          fillOpacity: 0.5
        },
        {
          field: 'EIGENTUEMER_TYP',
          value: 3,
          strokeColor: '#4E4E4EFF',
          fillColor: '#A3FF737F',
          fillOpacity: 0.5
        },
        {
          field: 'EIGENTUEMER_TYP',
          value: 1,
          strokeColor: '#000000FF',
          fillColor: '#00000000',
          fillOpacity: 0.5
        },
      ]
    },
    {
      fkIdentifyLayer: LayerCode.strategieflaeche,
      fkIdentifyLayerId: 6,
      queryLayerId: LayerCode.f_public_strategieflaeche,
      outfields: [
        'ID',
        'BEZEICHNUNG',
        'STRATEGIE',
        'BEGRUENDUNG_GRSTRAT',
        'FLAECHE',
      ],
      style: {
        strokeColor: '#ff0000',
        fillColor: '#ff7f7f',
        fillOpacity: 0.6
      },
      dynamicStyles: [
        {
          field: 'STRATEGIE',
          value: 101,
          strokeColor: '#ff0000',
          fillColor: '#ff7f7f',
          fillOpacity: 0.6
        },
        {
          field: 'STRATEGIE',
          value: 102,
          strokeColor: '#005ce6',
          fillColor: '#00c5ff',
          fillOpacity: 0.6
        },
        {
          field: 'STRATEGIE',
          value: 103,
          strokeColor: '#4c7300',
          fillColor: '#98e600',
          fillOpacity: 0.6
        },
        {
          field: 'STRATEGIE',
          value: 105,
          strokeColor: '#8400a8',
          fillColor: '#df73ff',
          fillOpacity: 0.6
        },
        {
          field: 'STRATEGIE',
          value: 104,
          strokeColor: '#e6e600',
          fillColor: '#ffff73',
          fillOpacity: 0.6
        },
        {
          field: 'STRATEGIE',
          value: 199,
          strokeColor: '#4e4e4e',
          fillColor: '#9c9c9c',
          fillOpacity: 0.6
        }
      ]
    },
    {
      fkIdentifyLayer: LayerCode.sap,
      fkIdentifyLayerId: 12,
      queryLayerId: LayerCode.f_public_refx_gb,
      outfields: [
        'IM_SCHLUESSEL',
        'BUCHUNGSKREIS',
        'WIRTSCHAFTSEINHEIT',
        'GEBAEUDE',
        'BEZEICHNUNG_DER_WE',
        'BEZ_GEBAEUDE',
        'GEBAEUDEART',
        'GEMEINDE',
        'PROFITCENTER'
      ],
      style: {
        fillColor: '#a80800',
        fillOpacity: 0.7,
        strokeColor: '#000000'
      }
    },
    {
      fkIdentifyLayer: LayerCode.sap,
      fkIdentifyLayerId: 13,
      queryLayerId: LayerCode.f_public_refx_gr,
      outfields: [
        'IM_SCHLUESSEL',
        'BUCHUNGSKREIS',
        'WIRTSCHAFTSEINHEIT',
        'GRUNDSTUECK',
        'BEZEICHNUNG_DER_WE',
        'BEZ_GRUNDSTUECK',
        'GEMEINDE',
        'PROFITCENTER',
      ],
      style: {
        fillColor: '#157300',
        fillOpacity: 0.7,
        strokeColor: '#000000'
      }
    },
    {
      fkIdentifyLayer: LayerCode.verkaufsobjekte,
      fkIdentifyLayerId: 9,
      queryLayerId: LayerCode.f_public_verkaufsobjekte,
      outfields: [
        'ID_SAP',
        'EGRIS_EGRID',
        'VERKAUFSOBJEKTART',
        'BEMERKUNG',
      ],
      style: {
        fillColor: '#b2b2b2',
        fillOpacity: 0.6,
        strokeColor: '#6e6e6e',
        strokeWeight: 0
      },
      dynamicStyles: [
        {
          field: 'VERKAUFSOBJEKTART',
          value: '0',
          fillColor: '#00e6a9',
          fillOpacity: 0.6,
          strokeColor: '#00734c',
          strokeWeight: 1
        },
        {
          field: 'VERKAUFSOBJEKTART',
          value: '1',
          fillColor: '#00c5ff',
          fillOpacity: 0.6,
          strokeColor: '#005ce6',
          strokeWeight: 1
        }
      ]
    }
  ]
};

export let GOOGLE_MAP_CONFIG_TOKEN = new InjectionToken<any>('app.googleMapConfig');

/* Export module */
@NgModule({
  providers: [
    {
      provide: GOOGLE_MAP_CONFIG_TOKEN,
      useValue: GOOGLE_MAP_CONFIG,
    },
  ],
})
export class GoogleMapConfigModule {}
